import { Component, OnInit } from '@angular/core';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { NgIf } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { BookingContentService } from 'src/app/services/bookingContentService/booking-content.service';

@Component({
    selector: 'app-profile-strip-summary',
    templateUrl: './profile-strip-summary.component.html',
    styleUrls: ['./profile-strip-summary.component.scss'],
    imports: [NgIf]
})
export class ProfileStripSummaryComponent implements OnInit {
  userID!: string;
  employeeCode!: string;
  firstName!: string;
  lastName!: string;
  initials!: string;
  name!: string;
  companyName!: string;
  designation!: string;
  private destroy$ = new Subject<void>();
  content: any;

  constructor(
    private crypto: CryptoService,
    private contentService: BookingContentService
  ) { }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    })
    const safeString = (value: any, fallback: string): string => {
      const str = (value || '').toString().trim();
      return str.length ? str : fallback;
    };

    this.userID = this.crypto.getValueFromKey("USERID") as string;
    this.employeeCode = this.crypto.getValueFromKey("EMPLOYEECODE") as string;
    this.firstName = safeString(this.crypto.getValueFromKey("USERFNAME"), "User");
    this.lastName = safeString(this.crypto.getValueFromKey("USERLNAME"), "Name");
    this.companyName = safeString(this.crypto.getValueFromKey("COMPANYNAME"), "Company");
    this.designation = localStorage.getItem('designation') || '';

    const firstLetter = this.firstName.charAt(0).toUpperCase();
    const remainingFirstName = this.firstName.slice(1).toLowerCase();

    const lastLetter = this.lastName.charAt(0).toUpperCase();
    const remainingLastName = this.lastName.slice(1).toLowerCase();

    // const designationFirstLetter = this.designation.charAt(0).toUpperCase();
    // const remainingDesignation = this.designation.slice(1).toLowerCase();

    this.name = `${firstLetter}${remainingFirstName} ${lastLetter}${remainingLastName}`;
    this.initials = `${firstLetter}${lastLetter}`;
    // this.designation = `${designationFirstLetter}${remainingDesignation}`;
    this.designation = this.designation;
  }
}
